export const formatUsernameDisplay = (
  username?: string | null,
  fallback?: string | null,
  defaultValue = 'there',
) => {
  const primary = typeof username === 'string' ? username.trim() : '';
  const secondary = typeof fallback === 'string' ? fallback.trim() : '';

  const value = primary || secondary || defaultValue;

  if (value.length === 0) {
    return defaultValue;
  }

  return value.charAt(0).toUpperCase() + value.slice(1);
};

export default formatUsernameDisplay;
